import { apiRequest, handleCall } from 'syft-acp-core/api/call'

type ApiResult<T> = {
  payload: T
}

export const fetchShiftOvertimeRules = (shiftID: string | number) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({
      path: `/admin/shifts/${shiftID}/active_overtime_rules`,
      method: 'GET',
    })
    handleCall(req, (result: ApiResult<unknown>) => resolve(result.payload), reject)
  })
